module.exports = __webpack_public_path__ + "static/template-preview-d7524d69a79cc4dc2505ae0bd1ec75f1.png";